import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';

const API_BASE = `${process.env.REACT_APP_API_URL_admin}/sale-order/exports`;

const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

export const invoiceExportApi = createApi({
  reducerPath: 'invoiceExportApi',
  baseQuery,
  tagTypes: ['InvoiceExports'],
  endpoints: (builder) => ({
    exportOptions: builder.query({ query: () => '/options' }),
    exportJobs: builder.query({
      query: () => '',
      providesTags: ['InvoiceExports'],
    }),
    createExport: builder.mutation({
      query: (body) => ({ url: '', method: 'POST', body }),
      invalidatesTags: ['InvoiceExports'],
    }),
    cancelExport: builder.mutation({
      query: (id) => ({ url: `/${id}/cancel`, method: 'POST' }),
      invalidatesTags: ['InvoiceExports'],
    }),
  }),
});

export async function downloadInvoiceExport(job) {
  const token = getStorage('token');
  const response = await fetch(`${API_BASE}/${job.id}/download`, {
    headers: { authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Unable to download export file');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = job.filename || 'invoice-export.csv';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export const {
  useCancelExportMutation,
  useCreateExportMutation,
  useExportJobsQuery,
  useExportOptionsQuery,
} = invoiceExportApi;
